export const Publications = Object.freeze({
  listOrgs: 'listOrgs',
  listMyOrgs: 'listMyOrgs',
  listUsers: 'listUsers',
  listAccounts: 'listAccounts',
  listAccountUsers: 'listAccountUsers',
  tailLogs: 'tailLogs',
  listSupportTicketMessages: 'listSupportTicketMessages',
  conversationMessages: 'conversationMessages',
  conversations: 'conversations',
  unreadMessageReceipts: 'unreadMessageReceipts',
  notifications: 'notifications',
  notificationsCount: 'notificationsCount',
  getProject: 'getProject',
  realtimeUpdate: 'realtimeUpdate',
  botTerminal: 'botTerminal',
  bots: 'bots',
  // Public, unauthenticated subscriptions for the customer site (curated /
  // projected; see publicProjections.ts).
  publicBots: 'public.bots',
  publicCardPrices: 'public.cardPrices',
});